import { defineComponent as _defineComponent } from 'vue'
import { useInstance } from '@/composables/useInstance';

type UserButtonProps = {
  name: string,
  icon: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserButton',
  props: {
    name: null,
    icon: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { name: string, icon: boolean }



const { $user, } = useInstance();


return { __sfc: true,props, $user }
}

})